<template>
	<div>
		<k-modal
			id="inviteStepHistoryModal"
			:title="$t('modals.inviteStepHistory.title', [stepName])"
			:okTitle="$t('buttons.close')"
			size="lg"
			@hidden="hideModal"
			okOnly
			okVariant="info"
		>
			<template v-slot:content>
				<div v-for="(history, index) in stepHistory" :key="index" class="mb-2" v-html="history"></div>
				<span v-if="!stepHistory.length"> {{ $t("modals.inviteStepHistory.thereIsAnyDetail") }} </span>
			</template>
		</k-modal>
	</div>
</template>

<script>
import KModal from "./KModal.vue";

export default {
	components: { KModal },

	data() {
		return {
			stepName: "",
			stepHistory: []
		};
	},
	methods: {
		setPropertiesOnModal({ changeLog }, stepName) {
			this.stepName = stepName ?? "";
			this.stepHistory = changeLog.map(
				({ action, newValue, oldValue, propertieName, propertieType, userName, impersonatorName, when, requirementDescription }) => {
					const formatDate = this.$functions.formatDateWorkflowDetails(when);
					const displayName = this.$functions.formatImpersonatorDisplayName(this, userName, impersonatorName);
					switch (propertieType) {
						case this.$ChangedPropertieType.REQUIREMENT_VALIDITY:
							return action === "create" || oldValue == undefined
								? `${formatDate} - <b>${displayName}</b> ${this.$t("modals.inviteStepHistory.insertRequirementValidity", [
										newValue,
										propertieName,
										requirementDescription
								  ])}`
								: `${formatDate} - <b>${displayName}</b> ${this.$t("modals.inviteStepHistory.updateRequirementValidity", [
										propertieName,
										oldValue,
										newValue ?? "--",
										requirementDescription
								  ])}`;
						case this.$ChangedPropertieType.REQUIREMENT_OBSERVATION:
							return action === "create" || oldValue == undefined
								? `${formatDate} - <b>${displayName}</b> ${this.$t("modals.inviteStepHistory.insertRequirementObservation", [
										newValue,
										propertieName,
										requirementDescription
								  ])}`
								: `${formatDate} - <b>${displayName}</b> ${this.$t("modals.inviteStepHistory.updateRequirementObservation", [
										propertieName,
										oldValue,
										newValue ?? "--",
										requirementDescription
								  ])}`;
						case this.$ChangedPropertieType.REQUIREMENTQUESTION_ANSWER:
							return action === "create" || oldValue == undefined
								? `${formatDate} - <b>${displayName}</b> ${this.$t("modals.inviteStepHistory.insertQuestionAnswer", [
										newValue,
										propertieName,
										requirementDescription
								  ])}`
								: action === "delete" || newValue == undefined
								? `${formatDate} - <b>${displayName}</b> ${this.$t("modals.inviteStepHistory.deleteQuestionAnswer", [
										oldValue,
										propertieName,
										requirementDescription
								  ])}`
								: `${formatDate} - <b>${displayName}</b> ${this.$t("modals.inviteStepHistory.updateQuestionAnswer", [
										propertieName,
										oldValue,
										newValue ?? "--",
										requirementDescription
								  ])}`;
					}
				}
			);
		},
		hideModal() {
			this.stepName = "";
			this.stepHistory = [];
		}
	}
};
</script>

<style scoped></style>
